import axios from 'axios';
import { getExpressAPIHost } from '../../utils';

const fetchScaleReadingRouteSessionCandidates = async ({ date_start, date_end, include_route_session_id, processor_id }) => {
    const params = {
        date_start: new Date(date_start).toISOString(),
        date_end: new Date(date_end).toISOString(),
        ...(include_route_session_id ? { include_route_session_id } : {}),
        ...(processor_id ? { processor_id } : {}),
    };
    try {
        const resp = await axios.get(`${getExpressAPIHost()}/dropoffs/scale-reading-candidates`, { params });
        return resp.data;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        throw new Error('Unable to fetch scale reading route session candidates.');
    }
};

export default fetchScaleReadingRouteSessionCandidates;
